import {
  AbstractEngine,
  init_abstractEngine
} from "./chunk-YVKSXECI.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Engines/AbstractEngine/abstractEngine.texture.js
var init_abstractEngine_texture = __esm({
  "node_modules/@babylonjs/core/Engines/AbstractEngine/abstractEngine.texture.js"() {
    "use strict";
    init_abstractEngine();
    AbstractEngine.prototype.createDepthStencilTexture = function(size, options, rtWrapper) {
      if (options.isCube) {
        const width = size.width || size;
        return this._createDepthStencilCubeTexture(width, options);
      } else {
        return this._createDepthStencilTexture(size, options, rtWrapper);
      }
    };
  }
});

export {
  init_abstractEngine_texture
};
